"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportCsvButton = void 0;
const react_1 = __importDefault(require("react"));
const use_export_products_hook_1 = require("../../hooks/use-export-products.hook");
const table_export_csv_button_1 = require("../../../../../common/table-export-csv-button");
const store_1 = require("../../../../../../store");
const ExportCsvButton = () => {
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const { exportProducts, loading } = (0, use_export_products_hook_1.useExportProducts)({
        catalogId: selectedCatalogId,
    });
    return (react_1.default.createElement(table_export_csv_button_1.TableExportCsvButton, { onClick: exportProducts, loading: loading }));
};
exports.ExportCsvButton = ExportCsvButton;
